import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const ProtectedRoute = ({ children,  page }) => {
  const { users } = useSelector((state) => state.user || {});
  // console.log(users)
  // Not logged in
  if (!users) {
    return <Navigate to="/login" replace />;
  }

  if (
    page &&
    !users?.accessPages?.map(p => p.toLowerCase())?.includes(page.toLowerCase())
  ) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default ProtectedRoute;
